import { render, staticRenderFns } from "./QuestionChangeSettings.vue?vue&type=template&id=fbccee70"
import script from "./QuestionChangeSettings.vue?vue&type=script&lang=ts"
export * from "./QuestionChangeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports